import { ProductImageViewModel } from '@/types/api';
import usePDPData from '@/app/(pdp)/_utils/use-pdp-data';
import { VariantContextType } from '@/app/(pdp)/context/types';
import { useVariantContextValues } from '@/app/(pdp)/context/use-variant-context-values';
import { PDPThumbnailType } from '../types';
export function useGallaryItems(contextType: VariantContextType, slug?: string) {
  const {
    data
  } = usePDPData(slug);
  const {
    selectedVariant,
    hasColorOptions
  } = useVariantContextValues(contextType);
  const showSelectedVariantImages = !!hasColorOptions && !!selectedVariant;
  if (showSelectedVariantImages) {
    const images = selectedVariant?.color?.images || [];
    const thumbnails: PDPThumbnailType[] = images.map((image, index) => ({
      id: image.id ?? String(index),
      imageUrl: image.imageUrl ?? '',
      isVideo: false
    }));
    return {
      images,
      thumbnails,
      videos: [],
      totalCount: thumbnails.length
    };
  }
  const mainImage: ProductImageViewModel = {
    id: 'main-image',
    imageUrl: data?.mainImageUrl
  };
  let images = [];
  data?.mainImageUrl && images.push(mainImage);
  data?.images && data?.images?.length && (images = [...images, ...(data?.images || [])]);
  const imagesThumbnails = images.map<PDPThumbnailType>((image, index) => ({
    id: image.id ?? String(index),
    imageUrl: image.imageUrl ?? '',
    isVideo: false
  }));
  const videos = data?.videos || [];
  const videosThumbnails = videos?.map<PDPThumbnailType>(({
    id,
    thumbnailImageUrl,
    videoUrl
  }, index) => ({
    id: id ?? String(index),
    imageUrl: thumbnailImageUrl ?? '',
    videoUrl: videoUrl ?? '',
    isVideo: true
  }));
  const thumbnails: PDPThumbnailType[] = [...imagesThumbnails, ...videosThumbnails];
  return {
    images,
    thumbnails,
    videos
  };
}